export default __webpack_public_path__ + "static/media/alamo-arte-8.f8e63cc9.webp";